export const TICKET_SOLD_LIST_ACTION = "TICKET_SOLD_LIST_ACTION";
export const TICKET_SOLD_LIST_SUCCESS = "TICKET_SOLD_LIST_SUCCESS";
export const TICKET_SOLD_LIST_FAIL = "TICKET_SOLD_LIST_FAIL";